'use strict';

import register from './core';
import '../functions/jquery-global.js';

register('file-input', function (element) {
  var $element = $(element);
  var imageInput = $element.find("#event-picture");
  //var isValid = true;
  imageInput.on('change', function () {
    $("#upload-error").hide();
    $("#extension-error").hide();
    
    if (!fileSizeValidation(imageInput))
      $("#upload-error").show();

    if (!fileNameValidation(imageInput))
      $("#extension-error").show();
  });
});

export function fileNameValidation(imageInput) {
  const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.ico|\.svg|\.jpe|\.jfif|\.webp)$/i;
  if ($(imageInput).get(0).files.length == 0) return true;
  var imageFile = $(imageInput).get(0).files[0];
  if (imageFile === undefined) return false;

  var filePath = imageFile.name;

  return allowedExtensions.exec(filePath);
}

export function fileSizeValidation(imageInput) {
  if ($(imageInput).get(0).files.length == 0) return true;
  var imageFile = $(imageInput).get(0).files[0];
  if (imageFile === undefined) return false;

  return imageFile.size < 2097153;
}
